import { useNavigate, NavigateOptions } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { isDefaultLocale, getLocalizedPath } from "../i18n";

export function useLocalizedNavigate() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const localizedNavigate = useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === "number") {
        navigate(to);
        return;
      }

      // Don't prefix external URLs
      if (to.startsWith("http://") || to.startsWith("https://") || to.startsWith("mailto:")) {
        window.location.href = to;
        return;
      }

      navigate(getLocalizedPath(to, i18n.language), options);
    },
    [navigate, i18n.language],
  );

  return localizedNavigate;
}

export function useLocalePrefix(): string {
  const { i18n } = useTranslation();
  return isDefaultLocale(i18n.language) ? "" : `/${i18n.language}`;
}
